import moment from "moment";
const HelperService = {

  getPageType() {
    return 'ADMIN_DEAL_PAGE';
  },
  loginToPreviousPortal() {
    var token: any = localStorage.getItem("token1");
    var UserData: any = localStorage.getItem("UserData1");
    var IsSuperAdmin: any = localStorage.getItem("IsSuperAdmin1");
    localStorage.removeItem("tenantId");
    localStorage.removeItem("api_base_url");
    localStorage.setItem("token", token);
    localStorage.setItem("UserData", UserData);
    localStorage.setItem("IsSuperAdmin", IsSuperAdmin);
    localStorage.removeItem("token1");
    localStorage.removeItem("UserData1");
    localStorage.removeItem("IsSuperAdmin1");
    return true;

  },
  SavePreviousPortalloginData() {
    var token: any = localStorage.getItem("token");
    var UserData: any = localStorage.getItem("UserData");
    var IsSuperAdmin1: any = localStorage.getItem("IsSuperAdmin");
    localStorage.removeItem("tenantId");
    localStorage.removeItem("api_base_url");
    localStorage.setItem("token1", token);
    localStorage.setItem("UserData1", UserData);
    localStorage.setItem("IsSuperAdmin1", IsSuperAdmin1);
    return true;

  },
  getLoginUserData(key: any) {
    const localdata = JSON.parse(localStorage.getItem("UserData") || "");
    return localdata[key];

  },
  getLoginUserData1(key: any) {
    const localdata = JSON.parse(localStorage.getItem("UserData1") || "");
    return localdata[key];

  },
  getUserId() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const userId = window.atob(encodeURIComponent(urlParams.get('UId') || "").replaceAll('%3D', '='));
    if (userId) {
      return userId;
    } else {
      const localdata = JSON.parse(localStorage.getItem("UserData") || "");
      return localdata.userId;
    }

  },
  getCampaignId() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const campaignId = window.atob(encodeURIComponent(urlParams.get('CId') || "").replaceAll('%3D', '='));
    return campaignId;
  },
  getWorkflowId() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const workflowId = window.atob(encodeURIComponent(urlParams.get('WfId') || "").replaceAll('%3D', '='));
    return workflowId;
  },
  getWorkflowTaskId() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const workflowTaskId = window.atob(encodeURIComponent(urlParams.get('WtId') || "").replaceAll('%3D', '='));
    return workflowTaskId;
  },
  getCompanyId() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const companyId = window.atob(encodeURIComponent(urlParams.get('CpId') || "").replaceAll('%3D', '='));
    return companyId;
  },

  getCompanyName() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const companyName = encodeURIComponent(urlParams.get('Cn') || "");
    return companyName;
  },
  getUserName() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const UserName = encodeURIComponent(urlParams.get('Cn') || "");
    return UserName;
  },
  formatPrice(value: number) {
    if (!value) {
      return 0.0;
    }
    return Intl.NumberFormat("en-US").format(value);
  },
  convertTobase64(dt: any) {
    return moment.utc(dt).local().format("MMM DD, YYYY");
  },
  getDateFormat(dt: any) {
    return moment.utc(dt).local().format("MMM DD, YYYY");
  },
  compareDate(dt: any) {
    const d1 = moment(new Date()).format("YYYY-MM-DD");
    const d2 = moment(dt).format("YYYY-MM-DD");
    const x = new Date(d1);
    const y = new Date(d2);
    if (y > x) {
      return true;
    } else {
      return false;
    }
  },
  getUpdatedFormatedDate(dt: any) {
    return moment.utc(dt).local().format("YYYY-MM-DD hh:mm:ss");
  },
  getUpdatedFormatedTime(dt: any) {
    return moment.utc(dt).local().format("YYYY-MM-DD | hh:mm A");
  },
  getUpdatedFormatedTimeWithSlash(dt: any) {
    return moment.utc(dt).local().format("DD/MM/YYYY  hh:mm A");
  },
  getFormatedTime(dt: any) {
    return moment.utc(dt).local().format("hh:mm A");
  },
  sendFormatedDate(dt: any) {
    return moment(dt).format("YYYY-MM-DD");
  },
  getTimeDifference(in_time: any) {
    in_time = this.getUpdatedFormatedDate(in_time);
    var out_time: any = this.getUpdatedFormatedDate(new Date());
    if (in_time && out_time && in_time < out_time) {
      var dateA = new Date(in_time);
      var dateB = new Date(out_time);
      var time = (dateB.getTime() - dateA.getTime()) / 1000;
      if (time > 0 && time < 60) {
        return Math.floor(time) + " secs ago";
      } else if (time > 60 && time < 3600) {
        time = time / 60;
        if (time > 1 && time < 2) {
          return Math.floor(time) + " min ago";
        } else {
          return Math.floor(time) + " mins ago";
        }
      } else if (time > 3600 && time < 86400) {
        time = time / 3600;
        if (time > 1 && time < 2) {
          return Math.floor(time) + " hr ago";
        } else {
          return Math.floor(time) + " hrs ago";
        }
      } else if (time > 86400) {
        time = time / 86400;
        if (time > 1 && time < 2) {
          return Math.floor(time) + " day ago";
        } else {
          return Math.floor(time) + " days ago";
        }
      }
    }
  },
  getCurrencyFormatter: function (e: any) {
    if (e || e == 0) {
      return new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
      }).format(e)
    } else {
      return e
    }
  },
  capitalizeFirst(string: string) {
    if (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    } else {
      return ''
    }
  },
  getFormatedDateInUs(d: any) {
    return d ? moment.utc(d).format("MM-DD-YY") : "";
  },
  getFormatedDayDate(d: any) {
    return d ? moment.utc(d).format("DD/MM/YY") : "";
  },

  getFormatedDate(d: any) {
    return d ? moment.utc(d).format("MM/DD/YY") : "";
  },

  getFormatedDatebyYYYY(d: any) {
    return d ? moment.utc(d).format("MM/DD/YYYY") : "";
  },

  getFormatedDateWithYear(d: any) {
    return d ? moment.utc(d).format("YYYY-MM-DD") : "";
  },

  getFormatedDateandYear(d: any) {
    return d ? moment.utc(d).format("YYYY-M-D") : "";
  },

  getFormatedDateAndTime(dt: any) {
    return moment.utc(dt).format("MM/DD/YY, hh:mm A");
  },

  getFormatedDateAndTimeWithoutUTC(dt: any) {
    return moment(dt).local().format("MM/DD/YY, hh:mm A");
  },

  getFormatedDateForTimePicker(dt: any) {
    return moment.utc(dt).format("YYYY-MM-DD hh:mm:ss");
  },

  getFormatedDateForSorting(dt: any) {
    if (dt) {
      return moment(dt).format("YYYY-MM-DD");
    }
  },

  getText(text: any, length: any) {
    if (text && length && text.length > length) {
      return text.substring(0, length) + '...';
    }

    return text;
  },
  getText2(text: any, length: any) {
    if (text && length && text.length > length) {
      return text.substring(0, length);
    }

    return text;
  },
  getFormatedDatewithMonthName(dt: any) {
    return moment(dt).format("MMM DD, YYYY");
  },
  getOrderDateFormat(dt: any) {
    return moment.utc(dt).local().format("DD-MM-YYYY");
  },
  getOrderDateFormatWithSlash(dt: any) {
    return moment.utc(dt).local().format("DD/MM/YYYY");
  },
  getOrderDateFormatWithTime(dt: any) {
    return moment.utc(dt).local().format("DD-MM-YYYY HH:mm a");
  },
  getDateFormate(dt: any) {
    return moment(dt).format("DD-MM-YYYY");
  },

  getFormateDatewithTime(dt: any) {
    return moment(dt).format('MMMM Do YYYY, h:mm a'); // April 26th 2024, 1:07:32 pm;
  },
  maxNumber(e: any, maxNumber: number) {
    if (maxNumber && e.currentTarget.value.length > maxNumber) {
      e.preventDefault();
      return false;
    }
  },
  isValidEmail(email: string) {
    let strRegex = new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i);
    return email ? strRegex.test(email) : true;
  },

  isValidPassword(password: string) {
    let strRegex = new RegExp(/^^(?=.*[A-Za-z0-9])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,20}$/);
    return password ? strRegex.test(password) : true;
  },
  isHtml(input: any) {
    let strRegex = new RegExp(/<[a-z]+\d?(\s+[\w-]+=("[^"]*"|'[^']*'))*\s*\/?>|&#?\w+;/i);
    return input ? strRegex.test(input) : true;
  },
  isValidurlPatternValidation(URL: any) {

    const regex = new RegExp(
      /^((http|https):\/\/.)[-a-zA-Z0-9@:%._\\+~#=]{2,256}\.[a-z]{2,15}\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)$/g
    );
    return URL ? regex.test(URL) : true;
  },
  removeUnderscoreWithCapitalLetter(str: any) {
    // Replace underscores with spaces
    const stringWithSpaces = str.replace(/_/g, ' ');

    // Capitalize the first letter of each word
    const words = stringWithSpaces.split(' ');
    const capitalizedWords = words.map((word: string) => word.charAt(0).toUpperCase() + word.slice(1));

    // Join the words back together
    const result = capitalizedWords.join(' ');

    return result;
  },
  allowOnlyNumericValue(e: any, maxlength?: any) {
    var numbers = /^[0-9]$/;
    if (!e.key.match(numbers) && e.keyCode != 8) {
      e.preventDefault();
      return false;
    }

    if (maxlength > 0) {
      if (e.key != "Backspace" && e.target.value.length >= maxlength) {
        e.preventDefault();
        return false;
      }
    }
  },
  allowNewDecimalValue(e: any) {
    const keyCode = e.keyCode ? e.keyCode : e.which;

    if (
      (keyCode < 48 || keyCode > 57) &&
      (keyCode !== 46 || e.target.value.indexOf(".") !== -1)
    ) {
      e.preventDefault();
      return false;
    }

    if (
      e.target.value &&
      e.target.value.indexOf(".") > -1 &&
      e.target.value.split(".")[1].length > 1 &&
      (e.target.selectionStart === e.target.value.length ||
        e.target.selectionStart === e.target.value.length - 1 ||
        e.target.selectionStart === e.target.value.length - 2)
    ) {
      e.preventDefault();
      return false;
    }
  },

  allowMaxValue(e: any, maxlength?: any) {
    if (maxlength && maxlength > 0) {
      if (e.key != "Backspace" && e.target.value.length >= maxlength) {
        e.preventDefault();
        return false;
      }
    }
  },
  allowDecimalValue(e: any) {
    var charCode = e.which ? e.which : e.keyCode;
    var number = e.target.value.split(".");
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
      e.preventDefault();
    }
    //just one dot
    if (number.length > 1 && charCode == 46) {
      e.preventDefault();
    }
    //get the carat position
    var caratPos = this.getSelectionStart(e.target);
    var dotPos = e.target.value.indexOf(".");
    if (caratPos > dotPos && dotPos > -1 && number[1].length > 1) {
      e.preventDefault();
    }
  },

  formateUptoTwoDecimal(e: any) {
    if (e && e.target) {
      e.currentTarget.value = this.formateDecimal(e.target.value);
    }
  },
  getSelectionStart(o: any) {
    // if (o.createTextRange) {
    //   var r = document.selection.createRange().duplicate();
    //   r.moveEnd("character", o.value.length);
    //   if (r.text == "") return o.value.length;
    //   return o.value.lastIndexOf(r.text);
    // } else return o.selectionStart;
  },
  // allowOnlyDecimalValue(e: any) {
  //   var numbers = /^\d+(?:\.\d{1,2})?$/;
  //   if (!e.key.match(numbers) && e.keyCode != 8) {
  //     e.preventDefault();
  //     return false;
  //   }

  //   if (e.key != "Backspace" && e.target.value.length >= 10) {
  //     e.preventDefault();
  //     return false;
  //   }
  // },
  formateDecimal(value: any) {
    return value ? parseFloat(value).toFixed(2) : "";
  },
  geturlextension(url: any) {
    return url.split(/[#?]/)[0].split(".").pop().trim();
  },
  getTitleCase(value: any) {
    if (!value) {
      return "";
    } else {
      var str = "";
      var arr = value.split("_");
      for (var i in arr) {
        if (Number(i) == 0) {
          str =
            arr[i].charAt(0).toUpperCase() + arr[i].substring(1).toLowerCase();
        } else {
          str +=
            "" +
            arr[i].charAt(0).toUpperCase() +
            arr[i].substring(1).toLowerCase();
        }
      }
      return str;
    }
  },

  getTitleCaseWithSpace(value: any) {
    if (!value) {
      return "";
    } else {
      var str = "";
      var arr = value.split("_");
      for (var i in arr) {
        if (Number(i) == 0) {
          str =
            arr[i].charAt(0).toUpperCase() + arr[i].substring(1).toLowerCase();
        } else {
          str +=
            " " +
            arr[i].charAt(0).toUpperCase() +
            arr[i].substring(1).toLowerCase();
        }
      }
      return str;
    }
  },

  titleCase(str: any) {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
  },

  lowerCase(str: any) {
    var splitStr = str.toLowerCase().split(' ');
    return splitStr.join(' ');
  },


  startsWithCapital(word: any) {
    if (word.charAt(1) === word.charAt(1).toUpperCase()) {
      return word
    } else {
      var splitStr = word.toLowerCase().split(' ');
      for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      return splitStr.join(' ');
    }
  },
  getRoundOff: function (num: number) {
    return Math.round(num);
  },

  convertTimeTodate(value: any) {

    const [hours, minutes, seconds] = value.split(':');
    // Create a new Date object and set the time components
    const date = new Date();
    date.setHours(parseInt(hours, 10));
    date.setMinutes(parseInt(minutes, 10));
    date.setSeconds(parseInt(seconds, 10));
    return date;

  },
  getYear(value: any) {

    let date = new Date();
    const newDate = new Date(date); // Create a new Date object with the same date as the initial date
    newDate.setFullYear(value); // Set the year component of the new Date object
    return newDate;

  },
  seo(data: any) {
    data.title = data.title || "Default title";
    data.metaDescription = data.description || "Default description";
    document.title = data.title;
    var doc = document.querySelector('meta[name="description"]') as HTMLElement;
    if (doc) {
      doc.setAttribute("content", data.metaDescription);
    }
    // if (document.getElementsByTagName('meta') && document.getElementsByTagName('meta')[3]) {
    //   document.getElementsByTagName('meta')[3].content = "New meta description!"
    // }
  },
  removeHtml(data: string) {
    if (data) {
      return data
        .replace(/<\/?[^>]+(>|$)/g, " ")
        .replace(/\&nbsp;/g, "")
        .replaceAll("&amp;", "&")
        .replaceAll("&quot;", '"')
        .replaceAll("&#39;", "'")
        .replaceAll("&lt;", "<")
        .replaceAll("&gt;", ">")
        .trim();
    }

    return "";
  },
  getFontSizeFormat(font: any) {

    if (font) {
      return font + "px";
    }
    return "";
  },
  getColorFormat(color: any) {
    if (color) {
      return color;
    }
    return "";
  },
  IsFontBold(weight: any) {
    if (weight) {
      if (weight == 'bold') {
        return "bold"
      }
    }
    return "";
  }
  ,
  IsFontItalic(weight: any) {
    if (weight) {
      if (weight == 'italic') {
        return "italic"
      }
    }
    return "";
  },
  getBillTypeLabel(type: string) {
    switch (type) {
      case "DINE_IN": return "Dine In";
      case "PICK_UP": return "Pick Up";
      case "DELIVERY": return "Delivery";
      default: return type;
    }
  },
  groupOrderItems(items: any[]) {
    const grouped: { [key: string]: any } = {};
    items.forEach(item => {
      // Get name and price from item or item.menu
      const name = item.name || item.menu?.name || "";
      const price = item.price !== undefined ? item.price : (item.menu?.price || 0);
      const gross_price = (item.gross_price || item.menu?.gross_price) ? (item.gross_price || item.menu?.gross_price || 0) : price;
      const key = (name || `${new Date().getTime()}`) + "_" + price; // group by name and price
      if (!grouped[key]) {
        grouped[key] = { name, price, quantity: 0, gross_price };
      }
      grouped[key].quantity += item.quantity || 0;
    });
    return Object.values(grouped);
  },
  
  generateBillHTML(response: any, cashierName: string, focusedTable: any, companyInformation: any, tokenNumber: any, ViewtaxObj?: any, customerName?: string, customer_mobile?: string, paymentMethod?: string, groupedMenuItems?: any, bill_type?: string, totalAmount?: number) {
    let menu_items: any[] = [];
    if (!response || response === '' || (Array.isArray(response.order_items) && response.order_items.length === 0)) {
      menu_items = Array.isArray(groupedMenuItems) ? groupedMenuItems : [];
    } else {
      menu_items = HelperService.groupOrderItems(response.order_items || []);
    }
    const companyInfo = Array.isArray(companyInformation) ? companyInformation[0] : companyInformation;
    const companyAddress = companyInfo?.address ? companyInfo.address.split('\n').map((line: string) => line.trim()).filter(Boolean).join('<br>') : '';
    const gstNumber = companyInfo?.gst_number ? `GSTIN: ${companyInfo.gst_number}` : '';
    const now = new Date();
    const formattedTime = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
    const formattedDate = now.toLocaleDateString();
    const tax_obj = ViewtaxObj || response?.tax_obj || {};
    const totalQty = menu_items.reduce((a: number, b: any) => a + (b.quantity || 0), 0);
    const total = totalAmount !== undefined ? totalAmount : menu_items.reduce((a: number, b: any) => a + ((b.price || 0) * (b.quantity || 0)), 0);
    const subTotal = menu_items.reduce((a: number, b: any) => a + ((b.gross_price || b.menu?.gross_price || 0) * (b.quantity || 0)), 0);

    let itemsHTML = "";
    menu_items.forEach((item: any) => {
      const name = item.name || item.menu?.name || "";
      const price = (item.gross_price || item.menu?.gross_price) ? (item.gross_price || item.menu?.gross_price || 0) : item.price;
      const quantity = item.quantity || 0;
      itemsHTML += `
      <tr style="border-bottom: 1.5px solid;">
        <td class="col-item items">${name}</td>
        <td class="text-center items-size">${quantity}</td>
        <td class="text-right items-size">${price.toFixed(2)}</td>
        <td class="text-right items-size">${(price * quantity).toFixed(2)}</td>
      </tr>
    `;
    });
    let taxHTML = "";
    Object.keys(tax_obj).forEach((key) => {
      taxHTML += `
      <div style="display:flex; justify-content:flex-end; margin-top:3.7px;">
        <div>${tax_obj[key].title}:</div>
        <div class="text-right" style="margin-left:  7.5px;">${parseFloat(tax_obj[key].amount).toFixed(2)}</div>
      </div>
        `;
    });

    const cleanReceiptValue = (value: any) => {
      const text = String(value ?? '').trim();
      return text && text.toLowerCase() !== 'null' && text.toLowerCase() !== 'undefined' ? text : '';
    };
    const receiptCustomerName = cleanReceiptValue(customerName) || cleanReceiptValue(response?.customer_name) || 'Customer';
    const receiptCustomerMobile = cleanReceiptValue(response?.customer_contact) || cleanReceiptValue(customer_mobile);

    let billHtml = `
    <!doctype html>
    <html>
    <head>
    <meta charset="utf-8" />
    <title>Receipt</title>
    <style id="bill_styles">
    @page { size: 302px auto; margin: 0; margin-right: 30px;}
    .col-item { width: 45%; }
    html, body { margin: 0; padding: 0; width: 302px; background: #fff; font-family: Arial; }
    .receipt { width: 287px; padding: 4.5px 3.7px; font-size: 14px; line-height: 1.12; }
    .brand { font-size: 18px; font-weight: bold; text-align: center; margin-bottom: 3.7px; }
    .small { font-size: 12.8px; text-align: center; }
     .items { font-size: 15px; }
    .items-size { font-size: 14px; }
    table { width: 100%; border-collapse: collapse; margin-top: 7.5px; font-size: 13.2px; }
    th { padding: 3.7px 1.8px; font-size: 14px; font-weight: bold; }
    td { padding: 3.7px 1.8px; }
    hr { border: none; border-top: 1.8px dashed #000; margin: 7px 0; }
    .tot-row { font-size: 16px; font-weight: bold; margin-top: 7px; }
    .text-right { text-align: right; }
    .text-center { text-align: center; }
    </style>
    </head>
    <body>
    <div id="printableBuyBack">
    <div class="receipt">
    <div class="brand">${companyInfo?.company_name}</div>
    <div class="small">
      ${companyAddress}<br>
      PH: ${companyInfo?.mobile}<br>
      ${gstNumber}
    </div>
    <hr>
    <div>
      <div>
      <strong>Name:</strong> ${receiptCustomerName}${receiptCustomerMobile ? ` (M: ${receiptCustomerMobile})` : ''}
      </div>
      <div style="display:flex; justify-content:space-between;">  
          <div><strong>Date:</strong> ${formattedDate} ${formattedTime}</div>
          <div><strong>${this.getBillTypeLabel(response?.order_type || bill_type || "")}:</strong> ${focusedTable?.tableNo !== undefined && focusedTable?.tableNo !== null ? focusedTable.tableNo : (focusedTable || '')}</div>
      </div>
      <div style="display:flex; justify-content:space-between;">  
        <div><strong>Cashier:</strong> ${cashierName || 'biller'}</div>
        <div><strong>Bill No.:</strong> ${tokenNumber}</div>
      </div>
    </div>
    <table>
      <thead style="border-bottom: 2.5px solid;">
      <tr>
      <th style="text-align:left;" class="col-item">Item</th>
      <th style="text-align:center;">Qty</th>
      <th style="text-align:right;">Price</th>
      <th style="text-align:right;">Amt</th>
      </tr>
      </thead>
      <tbody>
      ${itemsHTML}
      <tr style="border-bottom: 1.5px solid;">
      <td class="items-size">Total Qty:</td>
      <td class="text-center">${totalQty}</td>
      <td class="text-right items">Total:</td>
      <td class="text-right items">${subTotal.toFixed(2)}</td>
      </tr>
      </tbody>
    </table>
    ${taxHTML}
    <div class="tot-row" style="display:flex; justify-content:flex-end;">
      <div>Grand Total:</div>
      <div class="text-right" style="margin-left: 7.5px;">₹${Math.round(total)}</div>
    </div>
    <div class="text-center" style="margin-top:7.5px;">Paid via ${paymentMethod || "CASH"}</div>
    <div class="text-center small" style="margin-top:3px; padding-bottom: 11px;">Thank You! Visit Again</div>
    </div>
    </div>
    </body>
    </html>`;
    return billHtml;
  },


};
export default HelperService;
